import { FieldEditorProps } from './FieldEditorProps';
import AsyncSelect from 'Shared/components/AsyncSelect'
import '../styles/Editors.scoped.scss';

export const SurveyFieldEditor = ({ field, onChange }: FieldEditorProps) => {
  const questionId = field?.questionId
  const campaignId = field?.config?.campaignId
  const flowId = field?.config?.flowId
  const surveySourceType = field?.config?.surveySourceType || (campaignId ? 'campaign' : '')

  const handleSourceTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newType = e.target.value
    onChange({
      questionId: null,
      config: { ...field.config, surveySourceType: newType, campaignId: null, flowId: null }
    })
  }

  const handleCampaignChange = (id: string) => {
    onChange({ questionId: null, config: { ...field.config, surveySourceType: 'campaign', campaignId: id, flowId: null } })
  }

  const handleFlowChange = (id: string) => {
    onChange({ questionId: null, config: { ...field.config, surveySourceType: 'page_ballot', campaignId: null, flowId: id } })
  }

  return <>
    <div className="field-editor-row">
      <label>Where's the survey question</label>
      <div className='field-editor-input'>
        <select value={surveySourceType} onChange={handleSourceTypeChange}>
          <option value="">Select...</option>
          <option value="campaign">A campaign</option>
          <option value="page_ballot">A page/ballot</option>
        </select>
      </div>
    </div>
    {surveySourceType === 'campaign' &&
      <div className="field-editor-row">
        <label>Campaign</label>
        <div className='field-editor-input'>
          <AsyncSelect
            entity="campaign"
            queryParameters={{ hasSurvey: 'y', excludeDraft: 'y' }}
            value={campaignId}
            rootClassName="grow"
            onChange={handleCampaignChange}
          />
        </div>
      </div>
    }
    {surveySourceType === 'page_ballot' &&
      <div className="field-editor-row">
        <label>Page/Ballot</label>
        <div className='field-editor-input'>
          <AsyncSelect
            entity="flow"
            queryParameters={{ hasSurvey: 'y' }}
            value={flowId}
            rootClassName="grow"
            onChange={handleFlowChange}
          />
        </div>
      </div>
    }
    {(campaignId || flowId || questionId) &&
      <div className="field-editor-row">
        <label>Question</label>
        <div className="field-editor-input">
          <AsyncSelect
            entity="question"
            value={questionId}
            rootClassName="grow"
            onChange={(id) => onChange({ questionId: id })}
            queryParameters={campaignId ? { campaignId } : { flowId }}
          />
        </div>
      </div>
    }
  </>
}
